import { createContext, useContext, useState } from 'react';

const ReportHelpPartnerContext = createContext();

const initialState = {};
const initialFilterState = {
  page: 1,
  limit: 10,
  sort: '',
  search: '',
  studioId: '',
  startedAt: null,
  endedAt: null,
};

const ReportHelpPartnerProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return <ReportHelpPartnerContext.Provider value={{ updateState, ...state, updateFilterState, filterState }}>{children}</ReportHelpPartnerContext.Provider>;
};

export const useReportHelpPartnerState = () => {
  return useContext(ReportHelpPartnerContext);
};

export default ReportHelpPartnerProvider;
